/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
import { motion } from 'framer-motion';
import React, { useState } from 'react';
import ThreeDotsLoader from '../LoadingDots';

export default function LoginScreen({
    Email,
    password,
    setEmail,
    setpassword,
    ValidateUserInput,
    isError,
    setisError,
    loading,
}) {
    const [visible, setVisible] = useState('password');

    return (
        <div>

            <div className="flex  h-custom w-full">
                <div className="w-[43%] sm:opacity-100 opacity-50">
                    <img src="/images/falcon_login_image.jpg" alt="icon" className="h-custom w-full" />
                </div>
                <div className="flex justify-center items-center h-auto w-[57%]">
                    <form onSubmit={(e) => ValidateUserInput(e)}>
                        <div className="admin-login">
                            <h5 className="text-xs1 font-bold text-[#555259] pb-6">
                                <span className="text-[#ED1C24]">FALCON</span>
                                {' '}
                                Login
                            </h5>
                            <p className="text-sm font-normal text-[#555259]">Using your registered email address and password</p>
                            {isError && (
                                <motion.p
                                    animate={{ y: 5 }}
                                    transition={{ ease: 'backIn', duration: 1, type: 'spring' }}
                                    className="text-sm font-semibold text-[#ED1C24] pt-3.5{} error-message"
                                >
                                    {isError !== '' ? (isError === true ? 'Invalid email address or password. Please re-enter to proceed.' : isError)
                                        : 'Invalid email address or password. Please re-enter to proceed.'}
                                </motion.p>
                            )}
                            <div className="pt-8">
                                <div className="relative">
                                    <input
                                        type="text"
                                        id="email"
                                        value={Email}
                                        className="px-3.5 p h-[60px] w-[360px] rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] error"
                                        autoComplete="off"
                                        onChange={(e) => setEmail(e.target.value)}
                                        onFocus={() => setisError(false)}
                                    />
                                    <label htmlFor="email" className="text-xs2 font-semibold  text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">Email Address</label>
                                </div>
                            </div>
                            <div className="pt-6">
                                <div className="relative">
                                    <input
                                        type={visible}
                                        id="password"
                                        value={password}
                                        className="px-3.5 p h-[60px] w-[360px] rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406]"
                                        autoComplete="off"
                                        onChange={(e) => setpassword(e.target.value)}
                                        onFocus={() => setisError(false)}
                                    />
                                    <label htmlFor="password" className="text-xs2 font-semibold  text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">Password</label>
                                    <img src={`images/${visible === 'password' ? 'show-password.png' : 'hide-password.svg'}`} alt="icon" className="absolute top-[22px] right-3.5 cursor-pointer p-r-1" onClick={() => setVisible(visible === 'password' ? 'text' : 'password')} />
                                </div>
                            </div>
                            <div className="flex justify-center pt-6 pb-6 next">
                                <motion.button
                                    whileHover={{ scale: 1.1 }}
                                    whileTap={{ scale: 0.9 }}
                                    type="submit"
                                    data-testid="submit-btn"
                                    disabled={loading}
                                    className="md:w-[310px] w-[250px] md:h-[52px] h-10 text-center bg-[#555259] md:rounded-2xl rounded-xl sm:text-lg sm:font-semibold text-base text-[#FFFFFF] hover:bg-[#808285] submit flex center justify-center items-center"
                                >
                                    {loading ? <ThreeDotsLoader /> : 'Submit'}
                                </motion.button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
